import { StateUtils } from '@spartacus/core';
import { WritableShoppingListSearchResult } from '../../../model';
import { UserActions } from '../actions';
import { ShoppingListActionTypes } from '../actions/shopping-list.action';

export const initialState: any = {
  lastUpdateTime: undefined,
  results: [],
};

export function reducer<T>(state: T = initialState, action: UserActions.ShoppingListActions | StateUtils.LoaderAction): T {
  switch (action.type) {
    case ShoppingListActionTypes.SearchWritableShoppingListsSuccess: {
      const _action = <UserActions.SearchWritableShoppingListsSuccess>action;
      const payload: WritableShoppingListSearchResult = _action.payload.searchResult;
      const results = payload.results.map((r) => r.code);

      return {
        ...state,
        lastUpdateTime: new Date().toISOString(),
        results,
      };
    }
    case ShoppingListActionTypes.SearchWritableShoppingListsFail: {
      return {
        ...state,
        lastUpdateTime: new Date().toISOString(),
      };
    }
  }

  return state;
}
